import { useEffect, useState } from 'react';

import { getServerTime } from 'services/dashboard.service';

// Offset servidor-cliente memorizado por sessão (escopo de módulo): a PRIMEIRA montagem
// da sessão paga a chamada de rede; as seguintes (troca de aba MAD⇄Diretoria, volta pelo
// guarda-chuva) resolvem sincronamente — sem rede e sem tela de loading.
let cachedServerOffset: number | null = null;

// Port do ApreciarRealizacao/index.tsx: hora do SERVIDOR congelada na montagem (o
// interval de relógio existe comentado no original; preservamos o comportamento).
// Com o offset cacheado, cada montagem congela a hora do servidor "de agora" — o mesmo
// valor que a chamada de rede devolveria.
export function useServerTime() {
  const [realDatetime, setRealDatetime] = useState<number>(() =>
    cachedServerOffset !== null ? Date.now() + cachedServerOffset : 0,
  );
  const [hasTime, setHasTime] = useState(() => cachedServerOffset !== null);

  useEffect(() => {
    if (cachedServerOffset !== null) return;

    getServerTime().then(timestamp => {
      cachedServerOffset = timestamp - Date.now();
      setRealDatetime(timestamp);
      setHasTime(true);
    });
  }, []);

  return { realDatetime, hasTime };
}
